import React from 'react';
import { Moon } from 'lucide-react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
export function Header() {
  const handlePurchase = () => {
    // Track AddToCart event before redirecting
    trackAddToCart();
    // Small delay to ensure tracking fires before redirect
    setTimeout(() => {
      window.location.href = 'https://pay.hotmart.com/U104232902M';
    }, 300);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-cream-200 shadow-sm" data-id="element-97">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between" data-id="element-98">
        <div className="flex items-center space-x-2" data-id="element-99">
          <Moon className="w-6 h-6 text-amber-600" data-id="element-100" />
          <span className="font-bold text-lg text-navy-900 uppercase tracking-tight" data-id="element-101">
            Dormir Sin Pensar
          </span>
        </div>

        <div className="flex items-center" data-id="element-102">
          <Button size="md" className="bg-amber-600 hover:bg-amber-700 text-white shadow-md" onClick={handlePurchase} data-id="element-103">
            Descargar por $7,99
          </Button>
        </div>
      </div>
    </header>;
}